<!-- Toolbar -->
<div class="inv-toolbar">
	<div class="inv-toolbar__actions">
		<a [routerLink]="'/inventory/create'" mat-stroked-button color="accent">New Item</a>
		<a [routerLink]="'/inventory/create/'+stockid" mat-stroked-button color="accent" *ngIf="stockid">Clone</a>
		<mat-slide-toggle [formControl]="include_disabled">Include Discontinued</mat-slide-toggle>
		<ng-container *ngIf="config.env.package == 'tires'">
			<mat-slide-toggle (change)="searchBySize = !searchBySize; columns()" [value]="searchBySize">Size Search</mat-slide-toggle>
		</ng-container>
	</div>
	<div class="inv-toolbar__filters">
		<mat-form-field appearance="outline" class="inv-toolbar__filter-field">
			<mat-label>Category</mat-label>
			<mat-select [formControl]="categoryControl" multiple="true">
				<mat-option *ngFor="let c of categories" [value]="c.categoryid">{{ c.categorydescription }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="inv-toolbar__filter-field">
			<mat-label>Product Line</mat-label>
			<mat-select [formControl]="productLineControl" multiple="true">
				<mat-option *ngFor="let p of productlines" [value]="p.line_field">{{ p.line_description }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="inv-toolbar__search" color="accent">
			<mat-spinner matPrefix diameter="24" *ngIf="searching"></mat-spinner>
			<span matPrefix *ngIf="allitems.length && !searching">
				<button mat-icon-button class="p-0" (click)="clearForm()"><mat-icon class="p-0">clear</mat-icon></button>
			</span>
			<input #itemSearch matInput [formControl]="itemSearchControl" placeholder="Search by Part# / Description…" (keydown)="onSearchKeydown($event)">
			<span matSuffix>
				<button mat-icon-button (click)="searchItems()"><mat-icon class="p-0">search</mat-icon></button>
			</span>
		</mat-form-field>
	</div>
</div>
<h3 class="text-center" *ngIf="!searching && itemSearchControl.value != '' && allitems && allitems.length == 0 && !typing">NO RESULTS FOR {{ itemSearchControl.value | uppercase }}</h3>

<!-- ── MOBILE CARD LIST ─────────────────────────────────────────── -->
<div class="inv-cards" *ngIf="isMobile && allitems.length">
	<div class="inv-card" *ngFor="let item of getCurrentPageRows(); let i = index"
		(click)="viewItem(item)"
		[class.inv-card--special]="item.specialflag">

		<div class="inv-card__header">
			<span class="copy-wrapper">
				<div class="copied-tooltip" *ngIf="copiedStockId === item.stockid"><small>Copied!</small></div>
				<button mat-icon-button (click)="copyToClipboard(item.stockid, $event)"><mat-icon>content_copy</mat-icon></button>
			</span>
			<span class="inv-card__stockid fw-bold text-primary" [innerHTML]="item.stockid | highlight:itemSearchControl.value"></span>
			<div class="inv-card__badges" (click)="$event.stopPropagation()" *ngIf="isBeauty()">
				<button type="button" class="status-badge"
					[class.status-badge--active]="isItemEnabled(item)"
					[class.status-badge--inactive]="!isItemEnabled(item)"
					[disabled]="!canChangeInventoryItemStatus()"
					(click)="toggleEnabled(item, $event)"
					[attr.title]="canChangeInventoryItemStatus() ? (isItemEnabled(item) ? 'Enabled – click to disable' : 'Disabled – click to enable') : 'Requires access level 5 or higher'">
					<span class="status-dot"></span>
					<span class="status-label">{{ isItemEnabled(item) ? 'Active' : 'Disabled' }}</span>
				</button>
				<button type="button" class="status-badge"
					[class.status-badge--disc]="isItemDiscontinued(item)"
					[class.status-badge--live]="!isItemDiscontinued(item)"
					[disabled]="!canChangeInventoryItemStatus()"
					(click)="toggleDiscontinued(item, $event)"
					[attr.title]="canChangeInventoryItemStatus() ? (isItemDiscontinued(item) ? 'Discontinued – click to reactivate' : 'Active – click to discontinue') : 'Requires access level 5 or higher'">
					<span class="status-dot"></span>
					<span class="status-label">{{ isItemDiscontinued(item) ? 'Disc.' : 'Live' }}</span>
				</button>
			</div>
		</div>

		<div class="inv-card__desc" [innerHTML]="item.description | highlight:itemSearchControl.value"></div>

		<div class="inv-card__meta">
			<span class="inv-card__meta-item"><span class="inv-card__label">Vendor</span><span [innerHTML]="item.supplierno | highlight:itemSearchControl.value"></span></span>
			<span class="inv-card__meta-item"><span class="inv-card__label">Line</span><span [innerHTML]="item.lineid | highlight:itemSearchControl.value"></span></span>
			<span class="inv-card__meta-item"><span class="inv-card__label">QOH</span><span class="qoh-pill" [ngClass]="getQohPillClass(getTotalQoh(item.qoh))">{{ getTotalQoh(item.qoh) | number }}</span></span>
			<span class="inv-card__meta-item" *ngIf="user.user.viewcost"><span class="inv-card__label">Cost</span><span class="currency-pill">{{ toNumber(item.cost) | currency }}</span></span>
			<span class="inv-card__meta-item"><span class="inv-card__label">Price</span>
				<span class="currency-pill">{{ toNumber(item.price) | currency }}</span>
				<span *ngIf="item.specialflag" class="currency-pill crossed-out">{{ toNumber(item.originalPrice) | currency }}</span>
			</span>
		</div>
	</div>
	<mat-paginator
		[pageSizeOptions]="page_size"
		[pageSize]="page_size_default"
		showFirstLastButtons
		aria-label="select page">
	</mat-paginator>
</div>

<!-- ── DESKTOP TABLE ───────────────────────────────────────────── -->
<div #tableWrapper *ngIf="!isMobile">
<table mat-table [dataSource]="items" matSort (matSortChange)="announceSortChange($event)" [ngClass]="allitems.length ? '': 'd-none'">

	<ng-container matColumnDef="stockid">
	  <th mat-header-cell *matHeaderCellDef mat-sort-header>Item#</th>
	  <td mat-cell *matCellDef="let item" class="p-1">
		<span class="inline-cell-content">
		  <span class="copy-wrapper">
			<div class="copied-tooltip" *ngIf="copiedStockId === item.stockid"><small>Copied!</small></div>
			<button mat-icon-button matTooltip="Copy Item#" matTooltipPosition="above" (click)="copyToClipboard(item.stockid, $event)"><mat-icon>content_copy</mat-icon></button>
		  </span>
		  <span class="fw-bold text-primary hover-underline ms-1" [innerHTML]="item.stockid | highlight:itemSearchControl.value"></span>
		</span>
	  </td>
	</ng-container>

	<ng-container matColumnDef="enabled" *ngIf="isBeauty()">
		<th mat-header-cell *matHeaderCellDef class="status-header">Enabled</th>
		<td mat-cell *matCellDef="let item" class="p-1 status-cell" (click)="$event.stopPropagation()">
			<button type="button" class="status-badge"
				[class.status-badge--active]="isItemEnabled(item)"
				[class.status-badge--inactive]="!isItemEnabled(item)"
				[disabled]="!canChangeInventoryItemStatus()"
				(click)="toggleEnabled(item, $event)"
				[attr.title]="canChangeInventoryItemStatus() ? (isItemEnabled(item) ? 'Enabled – click to disable' : 'Disabled – click to enable') : 'Requires access level 5 or higher'">
				<span class="status-dot"></span>
				<span class="status-label">{{ isItemEnabled(item) ? 'Active' : 'Disabled' }}</span>
			</button>
		</td>
	</ng-container>

	<ng-container matColumnDef="size" *ngIf="searchBySize">
		<th mat-header-cell *matHeaderCellDef mat-sort-header><span>Size</span></th>
		<td mat-cell *matCellDef="let item"><span [innerHTML]="(item.size) | highlight:itemSearchControl.value"></span></td>
	</ng-container>

	<ng-container matColumnDef="supplierno">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor</th>
		<td mat-cell *matCellDef="let item; let i = index" class="text-cell">
			<span *ngIf="i !== hoveredRowIndex && i !== highlightedRowIndex" class="text-cell__inner" [innerHTML]="item.supplierno | highlight:itemSearchControl.value"></span>
			<span *ngIf="i === hoveredRowIndex || i === highlightedRowIndex" class="text-cell__expanded" [innerHTML]="item.supplierno | highlight:itemSearchControl.value"></span>
		</td>
	</ng-container>

	<ng-container matColumnDef="lineid">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Product Line</th>
		<td mat-cell *matCellDef="let item; let i = index" class="text-cell">
			<span *ngIf="i !== hoveredRowIndex && i !== highlightedRowIndex" class="text-cell__inner" [innerHTML]="item.lineid | highlight:itemSearchControl.value"></span>
			<span *ngIf="i === hoveredRowIndex || i === highlightedRowIndex" class="text-cell__expanded" [innerHTML]="item.lineid | highlight:itemSearchControl.value"></span>
		</td>
	</ng-container>

	<ng-container matColumnDef="description">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
		<td mat-cell *matCellDef="let item; let i = index" class="text-cell">
			<span *ngIf="i !== hoveredRowIndex && i !== highlightedRowIndex" class="text-cell__inner" [innerHTML]="item.description | highlight:itemSearchControl.value"></span>
			<span *ngIf="i === hoveredRowIndex || i === highlightedRowIndex" class="text-cell__expanded" [innerHTML]="item.description | highlight:itemSearchControl.value"></span>
		</td>
	</ng-container>

	<ng-container matColumnDef="qoh">
		<th mat-header-cell *matHeaderCellDef mat-sort-header class="num-header">QOH</th>
		<td mat-cell *matCellDef="let item" class="num-cell">
			<span class="qoh-pill" [ngClass]="getQohPillClass(getTotalQoh(item.qoh))" [innerHTML]="(getTotalQoh(item.qoh) | number) | highlight:itemSearchControl.value"></span>
		</td>
	</ng-container>

	<ng-container matColumnDef="cost">
		<th mat-header-cell *matHeaderCellDef mat-sort-header class="num-header">
			<span [ngClass]="!user.user.viewcost ? 'd-none': ''">Cost</span>
		</th>
		<td mat-cell *matCellDef="let item" class="num-cell">
			<span [ngClass]="!user.user.viewcost ? 'd-none': ''" class="currency-pill" [innerHTML]="(toNumber(item.cost) | currency) | highlight:itemSearchControl.value"></span>
		</td>
	</ng-container>

	<ng-container matColumnDef="price">
		<th mat-header-cell *matHeaderCellDef mat-sort-header class="num-header">Price</th>
		<td mat-cell *matCellDef="let item" class="num-cell">
			<span class="currency-pill" [innerHTML]="(toNumber(item.price) | currency) | highlight:itemSearchControl.value"></span>
			<span *ngIf="item.specialflag" class="currency-pill crossed-out" [innerHTML]="(toNumber(item.originalPrice) | currency) | highlight:itemSearchControl.value"></span>
		</td>
	</ng-container>

	<ng-container matColumnDef="discontinued" *ngIf="isBeauty()">
		<th mat-header-cell *matHeaderCellDef class="status-header">Discontinued</th>
		<td mat-cell *matCellDef="let item" class="p-1 status-cell" (click)="$event.stopPropagation()">
			<button type="button" class="status-badge"
				[class.status-badge--disc]="isItemDiscontinued(item)"
				[class.status-badge--live]="!isItemDiscontinued(item)"
				[disabled]="!canChangeInventoryItemStatus()"
				(click)="toggleDiscontinued(item, $event)"
				[attr.title]="canChangeInventoryItemStatus() ? (isItemDiscontinued(item) ? 'Discontinued – click to reactivate' : 'Active – click to discontinue') : 'Requires access level 5 or higher'">
				<span class="status-dot"></span>
				<span class="status-label">{{ isItemDiscontinued(item) ? 'Disc.' : 'Live' }}</span>
			</button>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="headercolumns; sticky: true;"></tr>
	<tr mat-row *matRowDef="let row; columns: headercolumns; let i = index" (click)="viewItem(row)" (mouseenter)="hoveredRowIndex = i" (mouseleave)="hoveredRowIndex = -1" [ngClass]="row.specialflag ? 'special' : ''" [class.inventory-row-highlight]="i === highlightedRowIndex"></tr>

</table>
<mat-paginator
  [pageSizeOptions]="page_size"
  [pageSize]="page_size_default"
  showFirstLastButtons
  aria-label="select page"
  [ngClass]="allitems.length ? '' : 'd-none'">
</mat-paginator>
</div>
